import { compose } from "redux";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import React, { PureComponent, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import Grid from "@material-ui/core/Grid";
import RootRef from "@material-ui/core/RootRef";
import Typography from "@material-ui/core/Typography";
import { scrollSmoothlyIntoViewIfNeeded } from "utils/app.util";

class Tab extends PureComponent {
  constructor(props) {
    super(props);

    this.rootRef = createRef();
  }
  componentDidMount() {
    const { selected } = this.props;

    if (selected) {
      scrollSmoothlyIntoViewIfNeeded(this.rootRef.current);
    }
  }

  render() {
    const {
      to,
      title,
      onClick,
      classes,
      children,
      selected,
      disabled,
      component,
    } = this.props;

    const Button = (
      <Grid
        onClick={onClick}
        disabled={disabled}
        component={component}
        className={classNames(classes.item, {
          [classes.itemSelected]: selected,
        })}
      >
        <Typography variant="body2" noWrap className={classes.itemText}>
          {title}
        </Typography>
        {children}
      </Grid>
    );

    return (
      <RootRef rootRef={this.rootRef}>
        {to ? <Link to={to}>{Button}</Link> : Button}
      </RootRef>
    );
  }
}

Tab.defaultProps = {
  component: ButtonBase,
};

const styles = theme => ({
  item: {
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    color: theme.palette.grey[800],
    padding: `${theme.spacing(2)}px ${theme.spacing(5)}px`,
    "&:hover": {
      background: "rgba(255, 255, 255, 0.4)",
    },
  },
  itemText: {
    fontWeight: 500,
  },
  itemSelected: {
    backgroundColor: theme.palette.background.default,
    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },
    "&.$item": {
      color: theme.palette.grey[800],
    },
  },
  itemDisabled: {},
  touchRipleRoot: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});

export default compose(
  withRouter,
  withStyles(styles),
)(Tab);
